import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Load2}          from "@Common/react/load2";

export const loadUserLevels = (next) => cs(
    consumeContext("apis"),
    ["userLevels", ({apis}, next) => Load2({
        fetch: () => apis.next.session.getUserLevels(),
        next,
    })],
    ({userLevels}) => next(userLevels),
);
